import { render, staticRenderFns } from "./TrueFalseIcon.vue?vue&type=template&id=4c6622e4"
import script from "./TrueFalseIcon.vue?vue&type=script&lang=js"
export * from "./TrueFalseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports